import { render, staticRenderFns } from "./addBatch.vue?vue&type=template&id=2bebdafe&"
import script from "./addBatch.vue?vue&type=script&lang=js&"
export * from "./addBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports